import React from "react"

import Layout from "../components/Layout"
import Seo from "../components/Seo"
import Posts from '../project/Posts'
import Hero from '../project/Hero'
import keffiyeh from '../images/keffiyeh.svg'

const IndexPage = () => (
  <Layout>
    <Seo title="Palestina, ¿La hora de la paz?" />
    <Hero>
      <img src={keffiyeh} className="keffiyeh" />
      <h1>La Tercera en<br /> Palestina</h1>
      <p>El gobierno de Donald Trump se apresta a lanzar un nuevo plan de paz para Medio Oriente, pero los palestinos miran con escepticismo. <strong>La Tercera</strong> fue invitada a Cisjordania por el gobierno palestino para recorrer la zona y dar una mirada a ese lado del conflicto.</p>
      <div className="credits">
        <span>Textos: <strong>Cristina Cifuentes</strong></span>
        <span>Fotos y videos: <strong>Álex Utreras</strong></span>
      </div>
    </Hero>
    <Posts />
  </Layout>
)

export default IndexPage
